import React, { useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import {
  ChevronDown,
  ChevronUp,
  Eye,
  EyeSlash,
  Search,
  QuestionCircleFill,
} from "react-bootstrap-icons";

import BG_URL from "../img/SG.png";
import LOGO_URL from "../img/tmis_logo_orig.png";

const API_BASE = process.env.REACT_APP_API || "";
const ENDPOINT_LOGIN = `${API_BASE}/login`;
const ENDPOINT_ADMIN_RESEND_OTP = `${API_BASE}/adminResendOTP`;
const ENDPOINT_ADMIN_OTP = `${API_BASE}/adminOTP`;

const STB_EMAIL = "stb_tourist_guide@stb.gov.sg";
const RENEW_EMAIL = "renew@tmis.edu.sg";
const WHATSAPP_NUMBER = "6598747292";
const WHATSAPP_DISPLAY = "+65 9874 7292";

const ExternalLink = ({ href, children }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.location.href = href;
  };

  return (
    <a href={href} className="a-link" onClick={handleClick}>
      {children}
    </a>
  );
};

const FAQ_ITEMS = [
  {
    question: "Why did STB change the licence renewal conditions?",
    searchText:
      "updated licence renewal conditions LEARN DO Future of Guiding 2.0 FOG 2.0 strengthen uplift tourist guide community raise standard guiding recognise different ways learning beyond classroom encourage ownership professional development remain active industry practical skills knowledge current licence renewal cycle",
    answer: (
      <>
        <p>
          The updated licence renewal conditions under LEARN + DO are part of
          STB's Future of Guiding 2.0 (FOG 2.0) vision to strengthen and uplift
          the tourist guide community.
        </p>
        <p>These changes aim to:</p>
        <ul className="faq-list-style">
          <li>Raise the standard of guiding.</li>
          <li>Recognise different ways of learning beyond the classroom.</li>
          <li>
            Encourage you to take greater ownership of your professional
            development.
          </li>
        </ul>
        <p className="mb-0 mt-3">
          The DO requirement also ensures that you remain active in the
          industry, so your practical skills and knowledge stay current
          throughout your licence renewal cycle.
        </p>
      </>
    ),
  },
  {
    question: "Who decides what LEARN + DO qualifies?",
    answer:
      "STB has appointed Approved Training Organisations (ATOs) to manage and validate your LEARN + DO submissions. Your assigned ATO will assess whether your submitted activities meet the requirements set out by STB in the guidebook.",
  },
  {
    question:
      "Why can I count my guiding assignments for locals and/or free tours as my DO?",
    answer:
      "Under Section 20(2) of the STB Act, a Tourist Guide licence is only required when providing guiding services to tourists for remuneration. As such, for licence renewal purposes, your DO requirement must follow the same principle. This means you need to complete 2 paid guiding assignments for tourists each year. While you may continue doing tours for locals or unpaid tours, these will not count towards your DO requirement.",
  },
  {
    question:
      "What if my employer does not allow me to take on paid guiding assignments?",
    searchText:
      "employment terms allow paid guiding assignments HR department formal declaration Email STB stb_tourist_guide declaration attached assess case by case",
    answer: (
      <>
        If your employment terms do not allow you to accept paid guiding
        assignments, please request your HR department to provide a formal
        declaration confirming this. Email STB at{" "}
        <ExternalLink href={`mailto:${STB_EMAIL}`}>{STB_EMAIL}</ExternalLink>{" "}
        with the declaration attached. STB will assess on a case by case basis.
      </>
    ),
  },
  {
    question: "Must I attend LEARN from the ATOs?",
    answer:
      "No. You are not restricted to LEARN activities conducted by your assigned ATO. You may participate in LEARN activities from any provider and submit them for validation. Your assigned ATO will review and assess whether the LEARN meets requirements. For more guidance, please refer to page 4 of the LEARN + DO Guidebook.",
  },
  {
    question: "How do I submit my LEARN + DO to STB?",
    searchText:
      "submit LEARN DO link provided assigned ATO review validate submissions update STB validation outcome consistent validation guidelines fair standardised assessment",
    answer: (
      <>
        <p>
          You will submit your LEARN + DO through the link provided by your
          assigned ATO. Your ATO will:
        </p>
        <ul className="faq-list-style">
          <li>Review and validate your submissions.</li>
          <li>Update STB on the validation outcome.</li>
        </ul>
        <p className="mb-0 mt-3">
          STB will provide consistent validation guidelines to all ATOs to
          ensure fair and standardised assessment.
        </p>
      </>
    ),
  },
  {
    question:
      "Can I go to any Approved Training Organisation (ATO) to validate my activities?",
    searchText:
      "randomly assigned ATO register assigned ATO submission link validate licence renewal submissions cannot switch ATO valid reason change assigned ATO email stb_tourist_guide STB assess case by case",
    answer: (
      <>
        You will be randomly assigned to an ATO and must register with your
        assigned ATO. Your ATO will provide you with the submission link and
        validate your licence renewal submissions. Do note that once you have
        registered with your ATO, you will no longer be able to switch ATOs.
        However, if there is a valid reason to change your assigned ATO, please
        write to{" "}
        <ExternalLink href={`mailto:${STB_EMAIL}`}>{STB_EMAIL}</ExternalLink>.
        STB will assess on a case by case basis.
      </>
    ),
  },
  {
    question: "Will I need to pay the ATOs for activity validation?",
    answer:
      "No. Currently, there is no fee for activity validation. You will continue to pay the licence renewal fee to STB via TRUST 2.0. There are no additional fees for LEARN + DO validation.",
  },
  {
    question: "How will LEARN + DO be tracked and verified?",
    answer:
      "All your submissions will be recorded in the TRUST 2.0 system. Your assigned ATO will validate and upload your submissions, while STB will oversee the licence renewal process to ensure consistency, transparency and fairness.",
  },
  {
    question: "What is the new system, TRUST 2.0?",
    answer:
      "TRUST 2.0 is STB's essential one-stop licensing and information hub portal for Travel Agents and Tourist Guides. It is an enhanced system used to manage key processes such as tourist guide licensing, licence renewals and LEARN + DO submissions.",
  },
  {
    question:
      "Where can I find activity listings for classroom courses, site-specific training or physical/virtual lectures?",
    answer:
      "STB will not be providing a fixed list of approved classroom courses or training programmes as LEARN + DO is designed to encourage Tourist Guides to take ownership of your professional development and to self-source learning opportunities that best meet your needs and interests. For guidance on the scope of permitted activities, please refer to page 4 of the LEARN + DO Guidebook.",
  },
  {
    question:
      "Can I complete all my 6 LEARN + 6 DO in one year instead of spreading them across the 3-year renewal cycle?",
    answer:
      "No. You cannot do all your LEARN + DO in one year. The requirement is for 2 LEARN and 2 DO to be completed each licence year. This ensures you stay active and keep your tourist guiding skills continuously updated.",
  },
  {
    question: "How do I contact my approved ATOs?",
    searchText: "contact TMIS renew email WhatsApp +65 9874 7292",
    answer: (
      <>
        You can contact TMIS at{" "}
        <ExternalLink href={`mailto:${RENEW_EMAIL}`}>
          {RENEW_EMAIL}
        </ExternalLink>{" "}
        or WhatsApp us at{" "}
        <ExternalLink href={`https://wa.me/${WHATSAPP_NUMBER}`}>
          {WHATSAPP_DISPLAY}
        </ExternalLink>
        .
      </>
    ),
  },
  {
    question: "Why do my LEARN submissions not get approved?",
    answer:
      "Please check the requirements for LEARN under the same page of the STB LEARN + DO Guidebook. Some Tourist Guides submit two LEARN activities under the same LEARN bucket, which is not allowed.",
  },
  {
    question: "What happens after my LEARN or DO submissions are approved?",
    searchText:
      "approved LEARN DO submissions uploaded TRUST following Monday STB up to three working days process approve submissions licence due renewal next six months view fulfilment status renew.tmis.edu.sg",
    answer: (
      <>
        All approved LEARN and DO submissions will be uploaded to TRUST on the
        following Monday. After the upload, the Singapore Tourism Board (STB)
        may take up to three working days to process and approve the
        submissions. Please note that only Tourist Guides whose licence is due
        for renewal within the next six months will be able to view their LEARN
        and DO fulfilment status on TRUST. If you wish to check the status of
        your LEARN and DO submissions before they are reflected on TRUST, please
        visit{" "}
        <ExternalLink href="https://renew.touristguide.sg">
          renew.touristguide.sg
        </ExternalLink>
        .
      </>
    ),
  },
  {
    question: "What are some reasons that DO submissions are not approved?",
    searchText:
      "reasons DO submissions not approved duplicate submissions transfer duties only administrative transfer services not guiding services commentaries detailed introductions Singapore sights attractions incomplete information remuneration details tour itineraries sites visited tourists assignment obtained local visitors multiple submissions same tour group",
    answer: (
      <>
        <p>Some common reasons include:</p>
        <ul className="faq-list-style">
          <li>Duplicate DO submissions are submitted.</li>
          <li>
            The assignment involves transfer duties only. Under STB guidelines,
            providing administrative or transfer services alone is not regarded
            as guiding services. The Tourist Guide must provide commentaries and
            detailed introductions to Singapore's sights and attractions during
            the tour.
          </li>
          <li>
            Incomplete information is provided. To facilitate prompt approval,
            please include remuneration details, tour itineraries (including
            sites visited), information about the tourists, and how the
            assignment was obtained.
          </li>
          <li>
            The tour is conducted for local visitors only. Tours for local
            visitors are not recognised as eligible DO submissions.
          </li>
          <li>
            Multiple DO submissions are made for the same tour group. Only one
            eligible DO submission may be counted for the same tour group.
          </li>
        </ul>
      </>
    ),
  },
  {
    question:
      "I am employed full-time as an in-house Tourist Guide. What should I do?",
    answer:
      "Please ask your employer to provide a letter confirming your employment as an in-house Tourist Guide. You are still required to submit your DO assignments; please include details of the tour itinerary and the tourists for each assignment.",
  },
];

const getFaqAnswerSearchText = (item) => {
  if (typeof item.answer === "string") return item.answer;
  return item.searchText || "";
};

export default function LoginPage() {
  const [form, setForm] = useState({
    username: "",
    password: "",
    remember: true,
  });
  const [showPw, setShowPw] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const [step, setStep] = useState("login");
  const [pendingUser, setPendingUser] = useState(null);

  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const otpRefs = useRef([]);
  const otp = otpDigits.join("");
  const faqRef = useRef(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [openFaqIndex, setOpenFaqIndex] = useState(0);

  const filteredFaqs = useMemo(() => {
    const q = searchTerm.trim().toLowerCase();
    if (!q) return FAQ_ITEMS;

    return FAQ_ITEMS.filter((item) => {
      const questionText = item.question || "";
      const answerText = getFaqAnswerSearchText(item);

      return (
        questionText.toLowerCase().includes(q) ||
        answerText.toLowerCase().includes(q)
      );
    });
  }, [searchTerm]);

  const scrollToFaq = () => {
    if (!faqRef.current) return;
    const top =
      faqRef.current.getBoundingClientRect().top + window.pageYOffset - 18;
    window.scrollTo({ top, behavior: "smooth" });
  };

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const validateLogin = () => {
    if (!form.username.trim() || !form.password) {
      return "Username and password are required. Please try again.";
    }
    return "";
  };

  const usernameClean = () => form.username.trim();

  const isStaffAccount = (user) => {
    const acct = String(user?.account_type || "")
      .toLowerCase()
      .trim();
    return acct === "staff";
  };

  const isAdminLike = (user) => {
    const acct = String(user?.account_type || "")
      .toLowerCase()
      .trim();
    return acct === "admin" || acct === "staff" || acct === "stbadmin";
  };

  const getClientInfo = () => {
    if (typeof navigator === "undefined") {
      return { device: "Unknown", browser: "Unknown", os: "Unknown" };
    }

    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";

    let browser = "Unknown";
    if (ua.includes("Firefox/")) browser = "Firefox";
    else if (ua.includes("Edg/")) browser = "Edge";
    else if (ua.includes("OPR/") || ua.includes("Opera")) browser = "Opera";
    else if (ua.includes("Chrome/")) browser = "Chrome";
    else if (ua.includes("Safari/")) browser = "Safari";
    else if (ua.includes("MSIE") || ua.includes("Trident/"))
      browser = "Internet Explorer";

    let os = "Unknown";
    if (ua.includes("Windows NT")) os = "Windows";
    else if (ua.includes("Mac OS X")) os = "macOS";
    else if (ua.includes("Android")) os = "Android";
    else if (/iPhone|iPad|iPod/.test(ua)) os = "iOS";
    else if (ua.includes("Linux")) os = "Linux";

    const device = /Mobi|Android|iPhone|iPad|iPod/.test(ua)
      ? "Mobile"
      : "Desktop";

    const platLower = platform.toLowerCase();
    if (os === "Unknown") {
      if (platLower.includes("win")) os = "Windows";
      else if (platLower.includes("mac")) os = "macOS";
      else if (platLower.includes("linux")) os = "Linux";
    }

    if (
      browser === "Unknown" &&
      platLower.includes("win") &&
      device === "Desktop"
    ) {
      browser = "Chrome";
    }

    const osFull = platform ? `${os} (${platform})` : os;
    return { device, browser, os: osFull };
  };

  const finalizeLogin = (token, user, rememberFlag) => {
    const uname =
      user.username || user.user_name || usernameClean() || form.username;

    localStorage.setItem("authToken", token);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("username", uname);
    localStorage.setItem("display_name", user.display_name || "");
    localStorage.setItem("account_type", user.account_type || "");

    if (!rememberFlag) {
      sessionStorage.setItem("authToken", token);
    }

    const target = isAdminLike(user) ? "/home" : "/userhome";
    setSuccessMsg("Login successful. Redirecting...");
    window.location.assign(target);
  };

  const sendStaffOtp = async (usernameForOtp) => {
    try {
      setSubmitting(true);
      setError("");
      setSuccessMsg("");

      await axios.post(
        ENDPOINT_ADMIN_RESEND_OTP,
        { username: usernameForOtp },
        { timeout: 20000 },
      );

      setSuccessMsg(
        "We have sent a 6-digit verification code to your registered email. Please enter it below to continue.",
      );
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        "Failed to send verification code. Please try again.";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      setError("Please enter the 6-digit verification code.");
      return;
    }

    const usernameForOtp =
      (pendingUser &&
        (pendingUser.user?.username || pendingUser.user?.user_name)) ||
      usernameClean();

    if (!usernameForOtp) {
      setError("Missing username. Please go back and login again.");
      return;
    }

    try {
      setSubmitting(true);
      setError("");
      setSuccessMsg("");

      const { data } = await axios.post(
        ENDPOINT_ADMIN_OTP,
        { username: usernameForOtp, otp },
        { timeout: 20000 },
      );

      if (!data?.success) {
        setError(
          data?.message || "Invalid verification code. Please try again.",
        );
        return;
      }

      if (!pendingUser?.token || !pendingUser?.user) {
        setError("Session error. Please login again.");
        return;
      }

      finalizeLogin(
        pendingUser.token,
        pendingUser.user,
        !!pendingUser.remember,
      );
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        (err?.response?.status === 401
          ? "Invalid verification code."
          : "Server error. Please try again later.");
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const handleResendOtpClick = async () => {
    const usernameForOtp =
      (pendingUser &&
        (pendingUser.user?.username || pendingUser.user?.user_name)) ||
      usernameClean();

    if (!usernameForOtp) {
      setError("Missing username. Please go back and login again.");
      return;
    }

    await sendStaffOtp(usernameForOtp);
    setOtpDigits(["", "", "", "", "", ""]);
    if (otpRefs.current[0]) otpRefs.current[0].focus();
  };

  const handleOtpChange = (index, value) => {
    const digit = value.replace(/\D/g, "").slice(0, 1);
    const next = [...otpDigits];
    next[index] = digit;
    setOtpDigits(next);

    if (digit && index < 5 && otpRefs.current[index + 1]) {
      otpRefs.current[index + 1].focus();
    }
  };

  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (otpDigits[index]) {
        const next = [...otpDigits];
        next[index] = "";
        setOtpDigits(next);
      } else if (index > 0 && otpRefs.current[index - 1]) {
        otpRefs.current[index - 1].focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      if (otpRefs.current[index - 1]) otpRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < 5) {
      if (otpRefs.current[index + 1]) otpRefs.current[index + 1].focus();
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMsg("");

    if (step === "otp") {
      await handleVerifyOtp();
      return;
    }

    const v = validateLogin();
    if (v) {
      setError(v);
      return;
    }

    try {
      setSubmitting(true);

      const uname = usernameClean();
      const { device, browser, os } = getClientInfo();

      const { data } = await axios.get(ENDPOINT_LOGIN, {
        params: {
          username: uname,
          password: form.password,
          device,
          browser,
          os,
        },
        timeout: 20000,
      });

      if (!data?.success) {
        setError(data?.message || "Login failed. Please try again.");
        return;
      }

      const token = data.token || "";
      const user = data.user || {};

      if (isStaffAccount(user)) {
        setPendingUser({ token, user, remember: form.remember });
        setStep("otp");
        setOtpDigits(["", "", "", "", "", ""]);
        await sendStaffOtp(
          user.username || user.user_name || uname || form.username,
        );
        setTimeout(() => {
          if (otpRefs.current[0]) otpRefs.current[0].focus();
        }, 100);
        return;
      }

      finalizeLogin(token, user, form.remember);
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        (err?.response?.status === 401
          ? "Invalid username or password."
          : "Server error. Please try again later.");
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const mainButtonLabel =
    step === "otp"
      ? submitting
        ? "Verifying…"
        : "VERIFY & LOGIN"
      : submitting
        ? "Logging in…"
        : "LOGIN";

  return (
    <div
      className="login-wrap"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundImage: `url(${BG_URL})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
        display: "flex",
        justifyContent: "center",
        overflowX: "hidden",
        paddingTop: "70px",
        paddingBottom: "110px",
        backgroundAttachment: "fixed",
      }}
    >
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "linear-gradient(to bottom, rgba(255, 255, 255, 0) 62%, rgba(255, 255, 255, 1) 100%)",
        }}
      />

      <style>{`
        .login-page-container {
          max-width: 1200px;
          padding-left: 16px;
          padding-right: 16px;
        }
        .login-form-col,
        .faq-col {
          display: flex;
          justify-content: center;
        }
        .faq-dropdown-content { margin-top: 2rem; }
        .faq-dropdown-content p { font-size: 15px; }
        .a-link {
          color: #2357d6;
          text-decoration: none;
          font-weight: 600;
        }
        .a-link:hover { text-decoration: underline; }
        .section-title {
          display: flex;
          align-items: center;
          text-align: center;
          margin: 20px 0;
        }
        .section-title::before,
        .section-title::after {
          content: "";
          flex: 1;
          border-bottom: 2px solid #585b62;
        }
        .section-title:not(:empty)::before { margin-right: 10px; }
        .section-title:not(:empty)::after { margin-left: 10px; }
        .section-title h6 {
          font-size: 18px;
          font-weight: 600;
          color: #585b62;
        }
        .register-card {
          width: 620px;
          max-width: 100%;
          background: linear-gradient(to bottom right, rgba(255,255,255,0.56), rgba(255,255,255,0.38)) border-box;
          backdrop-filter: blur(12px) saturate(120%);
          -webkit-backdrop-filter: blur(12px) saturate(120%);
          border: 1px solid rgba(255,255,255,0.45);
          border-radius: 22px;
          box-shadow: 0 12px 40px rgba(0,0,0,0.18), inset 0 0 0 1px rgba(255,255,255,0.18);
        }
        .register-card::before {
          content: "";
          position: absolute;
          inset: 0;
          border-radius: 22px;
          pointer-events: none;
          background: linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0));
          mix-blend-mode: screen;
        }
        .text-holder { border-radius: 10px; }
        .pr-eye { padding-right: 42px; }
        .eye-toggle {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          background: transparent;
          padding: 0 4px;
          cursor: pointer;
          line-height: 1;
        }
        .btn-register {
          padding: 12px 16px;
          font-weight: 700;
          letter-spacing: .6px;
          border-radius: 12px;
          box-shadow: 0 6px 20px rgba(0,0,0,0.18);
        }
        .otp-input-wrapper {
          display: flex;
          gap: 8px;
          justify-content: center;
          margin-top: 4px;
        }
        .otp-input {
          width: 44px;
          height: 48px;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          border-radius: 10px;
        }
        .faq-section-card {
          font-family: "Manrope", sans-serif;
          width: 100%;
          margin: 34px auto 0;
          padding: 36px 46px 40px;
          background: rgba(247, 247, 246, 0.96);
          border: 3px solid #333333;
          border-radius: 26px;
          box-shadow: 0 20px 46px rgba(0,0,0,0.18);
          text-align: left;
        }
        .faq-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 22px;
          margin-bottom: 22px;
        }
        .faq-title {
          margin: 0;
          font-size: 25px;
          line-height: 1;
          font-weight: 900;
          letter-spacing: 0.3px;
          color: #2f3034;
        }
        .faq-search-wrap {
          width: min(420px, 100%);
          position: relative;
          flex-shrink: 0;
        }
        .faq-search-input {
          width: 100%;
          height: 46px;
          border-radius: 999px;
          border: 1px solid #d8d8d8;
          background: #ffffff;
          padding: 0 52px 0 22px;
          outline: none;
          font-size: 16px;
          color: #333333;
          box-shadow: inset 0 1px 2px rgba(0,0,0,0.03);
        }
        .faq-search-input:focus {
          border-color: #b8b8b8;
          box-shadow: 0 0 0 3px rgba(0,0,0,0.05);
        }
        .faq-search-icon {
          position: absolute;
          right: 18px;
          top: 50%;
          transform: translateY(-50%);
          color: #777777;
          pointer-events: none;
        }
        .faq-list {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }
        .faq-item {
          background: #ffffff;
          border-radius: 10px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.12);
          overflow: hidden;
        }
        .faq-question-btn {
          width: 100%;
          min-height: 52px;
          border: 0;
          background: transparent;
          padding: 15px 18px 14px 22px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;
          text-align: left;
          color: #2f3034;
          font-size: 16px;
          font-weight: 800;
        }
        .faq-arrow {
          flex: 0 0 auto;
          color: #ef5572;
        }
        .faq-answer {
          padding: 0 22px 21px;
          color: #262626;
          font-size: 15px;
          line-height: 1.65;
        }
        .faq-answer p {
          margin-bottom: 14px;
          line-height: 1.8;
        }
        .faq-answer p:last-child { margin-bottom: 0; }
        .faq-list-style {
          margin: 12px 0 16px 24px;
          padding-left: 8px;
        }
        .faq-list-style li {
          margin-bottom: 12px;
          line-height: 1.8;
        }
        .faq-list-style li:last-child { margin-bottom: 0; }
        .faq-empty {
          margin: 0;
          padding: 18px 20px;
          background: #ffffff;
          border-radius: 10px;
          box-shadow: 0 8px 16px rgba(0,0,0,0.1);
          color: #555555;
        }
        .faq-note {
          margin: 20px 0 0;
          color: #555555;
          font-size: 14px;
          text-align: center;
        }
        .faq-floating-btn {
          font-family: "Manrope", sans-serif;
          position: fixed !important;
          right: max(18px, env(safe-area-inset-right));
          bottom: max(18px, env(safe-area-inset-bottom));
          z-index: 99999;
          width: 68px;
          height: 68px;
          min-width: 68px;
          min-height: 68px;
          padding: 0;
          border: 0;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          gap: 2px;
          color: #ffffff;
          background: linear-gradient(135deg, #ff4d5f 0%, #df1737 100%);
          box-shadow: 0 14px 34px rgba(0, 0, 0, 0.32);
          transition: transform 0.22s ease, box-shadow 0.22s ease;
        }
        .faq-floating-btn:hover,
        .faq-floating-btn:focus {
          transform: translateY(-4px);
          box-shadow: 0 18px 42px rgba(0, 0, 0, 0.36);
          background: linear-gradient(135deg, #ff4d5f 0%, #df1737 100%);
          color: #ffffff;
        }
        .faq-floating-btn svg {
          width: 24px;
          height: 24px;
        }
        .faq-floating-btn span {
          margin: 0 !important;
          font-size: 12px;
          line-height: 1;
          font-weight: 800;
          letter-spacing: 0.2px;
        }
        .faq-floating-btn::before {
          content: "";
          position: absolute;
          inset: -7px;
          border-radius: 50%;
          border: 2px solid rgba(223, 23, 55, 0.22);
          animation: faqPulse 1.8s ease-out infinite;
        }
        @keyframes faqPulse {
          0% { opacity: 0.85; transform: scale(0.86); }
          100% { opacity: 0; transform: scale(1.25); }
        }
        @media (prefers-reduced-transparency: reduce) {
          .register-card {
            background: rgba(255,255,255,0.92);
            backdrop-filter: none;
          }
        }
        @media (max-width: 992px) {
          .faq-section-card {
            width: 100%;
            max-width: 620px;
            padding: 30px 24px 34px;
            border-radius: 22px;
          }
          .faq-floating-btn {
            width: 62px;
            height: 62px;
            min-width: 62px;
            min-height: 62px;
          }
        }
        @media (max-width: 768px) {
          .login-wrap {
            padding-top: 28px !important;
            padding-bottom: 96px !important;
            align-items: flex-start;
            background-attachment: scroll !important;
          }
          .login-page-container {
            width: 100%;
            max-width: 100%;
            padding-left: 14px;
            padding-right: 14px;
          }
          .login-form-col,
          .faq-col {
            padding-left: 0;
            padding-right: 0;
          }
          .register-card {
            width: 100%;
            max-width: 620px;
            margin-left: auto !important;
            margin-right: auto !important;
            border-radius: 20px;
          }
          .register-card .card-body { padding: 22px 18px !important; }
          .faq-dropdown-content { margin-top: 1.35rem; }
          .faq-dropdown-content p {
            font-size: 14px;
            line-height: 1.55;
          }
          .section-title { margin: 18px 0; }
          .section-title h6 { font-size: 17px; }
          .faq-section-card {
            width: 100%;
            max-width: 620px;
            margin-top: 24px;
            padding: 26px 16px 28px;
            border-radius: 20px;
            border-width: 2px;
          }
          .faq-head {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
          }
          .faq-title {
            font-size: 22px;
            text-align: center;
          }
          .faq-search-wrap { width: 100%; }
          .faq-search-input {
            height: 44px;
            font-size: 14px;
          }
          .faq-question-btn {
            font-size: 14px;
            padding: 14px 14px 13px 16px;
          }
          .faq-answer {
            font-size: 13.5px;
            padding: 0 16px 18px;
          }
          .faq-floating-btn {
            right: max(14px, env(safe-area-inset-right));
            bottom: max(14px, env(safe-area-inset-bottom));
            width: 58px;
            height: 58px;
            min-width: 58px;
            min-height: 58px;
          }
          .faq-floating-btn svg {
            width: 22px;
            height: 22px;
          }
          .faq-floating-btn span { font-size: 11px; }
        }
        @media (max-width: 480px) {
          .login-wrap {
            padding-top: 18px !important;
            padding-bottom: 90px !important;
          }
          .login-page-container {
            padding-left: 10px;
            padding-right: 10px;
          }
          .register-card { border-radius: 18px; }
          .register-card .card-body { padding: 20px 16px !important; }
          .learn-do-title { font-size: 26px; }
          .otp-input {
            width: 40px;
            height: 44px;
            font-size: 18px;
          }
          .faq-section-card {
            padding: 22px 14px 26px;
            border-radius: 18px;
          }
          .faq-title { font-size: 20px; }
          .faq-question-btn {
            font-size: 13px;
            min-height: 50px;
          }
          .faq-answer { font-size: 12.5px; }
          .faq-floating-btn {
            right: max(12px, env(safe-area-inset-right));
            bottom: max(12px, env(safe-area-inset-bottom));
            width: 54px;
            height: 54px;
            min-width: 54px;
            min-height: 54px;
          }
          .faq-floating-btn span { display: none; }
        }
      `}</style>

      <Container className="login-page-container" style={{ zIndex: 1 }}>
        <Row className="justify-content-center text-center">
          <Col xs={12}>
            <img
              src={LOGO_URL}
              alt="TMIS Logo"
              style={{
                height: 90,
                objectFit: "contain",
                marginBottom: 18,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
          </Col>

          <Col xs={12} sm={10} md={8} lg={6} xl={5} className="login-form-col">
            <Card className="register-card position-relative mx-auto custom-font">
              <Card.Body style={{ padding: 24 }}>
                <h3
                  className="fw-bold text-center logo-font learn-do-title learn-do-logo"
                  style={{ letterSpacing: 1.1, marginBottom: 22 }}
                >
                  <span className="learn-text">LEARN</span>
                  <span className="plus-text"> + </span>
                  <span className="do-text">DO</span>
                </h3>

                {error ? (
                  <Alert variant="danger" className="mb-3">
                    {error}
                  </Alert>
                ) : null}
                {successMsg ? (
                  <Alert variant="success" className="mb-3">
                    {successMsg}
                  </Alert>
                ) : null}

                <Form onSubmit={onSubmit} style={{ textAlign: "left" }}>
                  <Form.Group className="mb-3" controlId="username">
                    <Form.Label className="custom-font">Email</Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder="Enter your email address"
                      value={form.username}
                      onChange={(e) => setField("username", e.target.value)}
                      className="text-holder"
                      autoComplete="username"
                      disabled={step === "otp"}
                    />
                  </Form.Group>

                  <Form.Group className="mb-2" controlId="password">
                    <Form.Label>Password</Form.Label>
                    <div className="position-relative">
                      <Form.Control
                        size="lg"
                        type={showPw ? "text" : "password"}
                        placeholder="Enter your password"
                        value={form.password}
                        onChange={(e) => setField("password", e.target.value)}
                        className="text-holder pr-eye"
                        autoComplete="current-password"
                        disabled={step === "otp"}
                      />
                      <button
                        type="button"
                        className="eye-toggle"
                        onClick={() => setShowPw((s) => !s)}
                        aria-label={showPw ? "Hide password" : "Show password"}
                        title={showPw ? "Hide password" : "Show password"}
                        disabled={step === "otp"}
                      >
                        {showPw ? <Eye size={18} /> : <EyeSlash size={18} />}
                      </button>
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="remember">
                    <Form.Check
                      type="checkbox"
                      label="Remember me"
                      checked={form.remember}
                      onChange={(e) => setField("remember", e.target.checked)}
                      disabled={step === "otp"}
                    />
                  </Form.Group>

                  {step === "otp" && (
                    <Form.Group className="mb-3" controlId="otp">
                      <Form.Label>Verification Code (OTP)</Form.Label>
                      <div className="otp-input-wrapper">
                        {otpDigits.map((digit, idx) => (
                          <Form.Control
                            key={idx}
                            ref={(el) => (otpRefs.current[idx] = el)}
                            type="text"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={(e) =>
                              handleOtpChange(idx, e.target.value)
                            }
                            onKeyDown={(e) => handleOtpKeyDown(idx, e)}
                            className="otp-input text-holder"
                          />
                        ))}
                      </div>
                      <Form.Text muted>
                        Please enter the 6-digit code sent to your registered
                        email.
                      </Form.Text>
                      <div className="mt-2">
                        <Button
                          variant="link"
                          type="button"
                          onClick={handleResendOtpClick}
                          disabled={submitting}
                          style={{ paddingLeft: 0 }}
                        >
                          Resend code
                        </Button>
                      </div>
                    </Form.Group>
                  )}

                  <div className="d-grid">
                    <Button
                      className="btn-register custom-font"
                      type="submit"
                      disabled={submitting}
                    >
                      {submitting && (
                        <Spinner
                          animation="border"
                          size="sm"
                          className="me-2"
                        />
                      )}
                      {mainButtonLabel}
                    </Button>
                  </div>
                </Form>

                <div className="mt-3 d-flex justify-content-between align-items-center">
                  <a href="/register" className="back-link">
                    Create an account
                  </a>
                  <a href="/forgotpassword" className="back-link">
                    Forgot password?
                  </a>
                </div>

                <div className="mt-3 d-flex align-items-center">
                  <a href="/resend" className="back-link ms-auto">
                    Resend Verification Link
                  </a>
                </div>

                <div className="faq-dropdown-content">
                  <div className="section-title">
                    <h6 className="m-0">For More Information</h6>
                  </div>
                  <p className="text-start">
                    For more information on LEARN + DO, please download the
                    LEARN + DO Guidebook from STB{" "}
                    <a
                      href="../L+D Guidebook 2.0_English.pdf"
                      target="_blank"
                      className="a-link"
                      rel="noreferrer"
                    >
                      English
                    </a>{" "}
                    &{" "}
                    <a
                      href="../L+D Guidebook 2.0_Mandarin.pdf"
                      target="_blank"
                      className="a-link"
                      rel="noreferrer"
                    >
                      Mandarin
                    </a>
                    .
                  </p>

                   <p className="text-start">
                    TMIS Tourist Guide Licence Renewal – LEARN+DO Video Guides{" "}
                    <a
                      href="https://www.youtube.com/playlist?list=PLZMo3dnLChx0"
                      target="_blank"
                      className="a-link"
                      rel="noreferrer"
                    >
                      Tourist Guide Licence Renewal – Learn+Do
                    </a>{" "}
                  </p>

                  <p className="text-start">
                    If you require further clarification, please email us at{" "}
                    <ExternalLink href={`mailto:${RENEW_EMAIL}`}>
                      {RENEW_EMAIL}
                    </ExternalLink>{" "}
                    or Whatsapp us at{" "}
                    <ExternalLink href={`https://wa.me/6598747292`}>
                      +65 9874 7292
                    </ExternalLink>{" "}
                  </p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} lg={11} xl={10} className="faq-col">
            <section
              ref={faqRef}
              className="faq-section-card"
              aria-labelledby="faq-title"
            >
              <div className="faq-head">
                <h2 id="faq-title" className="faq-title">
                  Frequently Asked Questions
                </h2>
                <div className="faq-search-wrap">
                  <input
                    type="text"
                    className="faq-search-input"
                    placeholder="Search..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setOpenFaqIndex(0);
                    }}
                    aria-label="Search FAQ"
                  />
                  <Search size={24} className="faq-search-icon" />
                </div>
              </div>

              <div className="faq-list">
                {filteredFaqs.length > 0 ? (
                  filteredFaqs.map((item, idx) => {
                    const isOpen = openFaqIndex === idx;
                    return (
                      <div className="faq-item" key={`${item.question}-${idx}`}>
                        <button
                          type="button"
                          className="faq-question-btn"
                          onClick={() => setOpenFaqIndex(isOpen ? -1 : idx)}
                          aria-expanded={isOpen}
                        >
                          <span>{item.question}</span>
                          {isOpen ? (
                            <ChevronUp size={22} className="faq-arrow" />
                          ) : (
                            <ChevronDown size={22} className="faq-arrow" />
                          )}
                        </button>
                        {isOpen && (
                          <div className="faq-answer">{item.answer}</div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <p className="faq-empty">No FAQ found for your search.</p>
                )}
              </div>

              <p className="faq-note">
                Need more help? Email{" "}
                <ExternalLink href={`mailto:${RENEW_EMAIL}`}>
                  {RENEW_EMAIL}
                </ExternalLink>{" "}
                or WhatsApp us at{" "}
                <ExternalLink href={`https://wa.me/${WHATSAPP_NUMBER}`}>
                  {WHATSAPP_DISPLAY}
                </ExternalLink>
                .
              </p>
            </section>
          </Col>
        </Row>
      </Container>

      <Button
        type="button"
        onClick={scrollToFaq}
        className="faq-floating-btn"
        aria-label="Go to FAQ section"
        title="Go to FAQ section"
      >
        <QuestionCircleFill />
        <span>FAQ</span>
      </Button>
    </div>
  );
}
